import { requestApi } from "../axios";
const prefix = 'khe-report/profile-report';

export function getKheProfileReportList(offset) {
    return requestApi(`${prefix}/list?limit=${10}&offset=${offset}`, 'GET');
}

// export function deleteGroupApi(id) {
//     return requestApi(`${prefix}/delete-group`, 'POST', { id });
// }

export function updateKheProfileStatusApi(id, status) {
    return requestApi(`${prefix}/update-report-status`, 'PUT', { id, status });
}

export function sendFeedbackKheProfileReportApi(content, userIdToSend, metadata) {
    return requestApi(`${prefix}/send-feedback-report`, 'POST', {
        content, userIdToSend, metadata
    });
}